
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import { isForeign, iDCardTypesLabel, formatOldCatType } from 'components/InvestorInfo/common/investorConfig'
import bingListenScroll from '../../../common/js/isReachBottom'
export default {
props: {
propData: {
type: [Object]
},
baseInfo: {
type: [Object]
},
hasResp: {
type: [Boolean],
default: false
}
},
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
Checker,
CheckerItem,
XTextarea,
Icon
},
data () {
return {
isReady: true,
twoData: {
representativeName: '',
representativeSex: '',
representativeAge: '',
representativeDocumentsType: '身份证',
representativeIdCardNo: '',
representativeDocumentsValidity: '',
representativePosition: '',
representativeLanline: '',
representativeMobile: '',
representativeEmail: '',
representativeZip: '',
representativeAddress: '',
legalCountry: '中国'
},
threeData: {
managersName: '',
managersSex: '',
managersAge: '',
managersDocumentsType: '',
managersIdCardNo: '',
managersDocumentsValidity: '',
managersPosition: '',
managersLanline: '',
managersMobile: '',
managersEmail: '',
managersZip: '',
managersAddress: '',
relationshipWithOrg: ''
},

question: {
isProfessionalInvestors: {
checked: ''
},
orgAssetsScale: {
checked: ''
},
isControllingShareholder: {
checked: '',
description: ''
},
transactionActualBeneficiary: {
checked: '',
description: ''
},
isBadFaith: {
checked: '',
description: ''
}
}
}
},
computed: {

isFund () {
return this.baseInfo.orgType !== 'futures'
}
},
created () {
bingListenScroll(this)
},
watch: {
hasResp (bool) {
if (bool) {
this.$_agency_init()
}
}
},
methods: {
isForeign,
iDCardTypesLabel,
$_agency_init () {
if (this.propData.oldInfo) {
let res = JSON.parse(this.propData.oldInfo)
this.twoData = {
representativeName: res.representativeName,
representativeSex: res.representativeSex,
representativeAge: res.representativeAge,
representativeDocumentsType: formatOldCatType(res.representativeDocumentsType),
representativeIdCardNo: res.representativeIdCardNo,
representativeDocumentsValidity: res.representativeDocumentsValidity,
representativePosition: res.representativePosition,
representativeLanline: res.representativeLanline,
representativeMobile: res.representativeMobile,
representativeEmail: res.representativeEmail,
representativeZip: res.representativeZip,
representativeAddress: res.representativeAddress,
legalCountry: res.legalCountry
}

this.threeData = {
managersName: res.managersName,
managersSex: res.managersSex,
managersAge: res.managersAge,
managersDocumentsType: res.managersDocumentsType,
managersIdCardNo: res.managersIdCardNo,
managersDocumentsValidity: res.managersDocumentsValidity,
managersPosition: res.managersPosition,
managersLanline: res.managersLanline,
managersMobile: res.managersMobile,
managersEmail: res.managersEmail,
managersZip: res.managersZip,
managersAddress: res.managersAddress,
relationshipWithOrg: res.relationshipWithOrg
}
this.$_agency_init_ques(res)
}
},

$_agency_init_ques (res) {
this.question = {
isProfessionalInvestors: {
checked: JSON.parse(res.isProfessionalInvestors).checked
},
orgAssetsScale: {
checked: JSON.parse(res.orgAssetsScale).checked
},
isControllingShareholder: {
checked: JSON.parse(res.isControllingShareholder).checked,
description: JSON.parse(res.isControllingShareholder).description
},
transactionActualBeneficiary: {
checked: JSON.parse(res.transactionActualBeneficiary).checked,
description: JSON.parse(res.transactionActualBeneficiary).description
},
isBadFaith: {
checked: JSON.parse(res.isBadFaith).checked,
description: JSON.parse(res.isBadFaith).description
}
}
},

$_agency_submit () {
let subObj = Object.assign({}, this.twoData, this.threeData, this.question, this.propData)
delete subObj.oldInfo
delete subObj.type
delete subObj.isNormal
this.$_agency_commit(subObj)
},
$_agency_commit (json) {
if (this.isDev) {
console.log(JSON.stringify(json))
} else {
this.$bridge.callHandler('getResult', {message: '最后确认', json: JSON.stringify(json)}, function (data) {
console.log('submit')
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Agency/OneLook.vue